"use client";

import { useEffect } from "react";

import { ANALYTICS_EVENTS, track, type EventProps } from "@/lib/analytics";

export function TrackView({
  event,
  props,
}: {
  event: keyof typeof ANALYTICS_EVENTS;
  props?: EventProps;
}) {
  // Serialised so a fresh object literal each render does not re-fire it.
  const key = JSON.stringify(props ?? {});
  useEffect(() => {
    track(ANALYTICS_EVENTS[event], JSON.parse(key) as EventProps);
  }, [event, key]);
  return null;
}
